import React from "react";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { DARKER_TEXT, BRAND_GREEN_PRIMARY, DARK_TEXT } from "resources/constants/colors";
import { IMAGES_URL } from "resources/constants/urls";
import NoProfileSVG from "resources/img/no-pic-therapist.png";
import styled from "styled-components";

const Container = styled.li`
    margin: 0;
    margin-bottom: 10px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);

    a {
        padding: 14px 16px;
        display: flex;
        gap: 10px;
        align-items: center;
        color: ${DARKER_TEXT};
        text-decoration: none;
    }

    .image-container {
        width: 55px;
        height: 55px;
        overflow: hidden;
        border-radius: 50%;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .information {
        flex: 1;
        min-height: 50px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .texts {
            color: ${DARKER_TEXT};
            h4 {
                font-size: 16px;
                margin: 0;
                user-select: none;
                margin-bottom: 5px;
            }
            p {
                font-weight: 600;
                font-size: 14px;
                margin: 0;

                &.enphasis {
                    font-style: oblique;
                    font-weight: 500;
                }
            }
        }
    }

    .unread {
        min-width: 34px;
        height: 34px;
        border-radius: 30px;
        background-color: ${BRAND_GREEN_PRIMARY};
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
            font-weight: 600;
        }
    }
`;

const getLastMessageText = (lastMessage) => {
    switch (lastMessage.type) {
        case "text":
            return lastMessage.payload.message;
        case "assignment":
            return "Invitación para aceptar asignación";
        default:
            return "";
    }
};

const ConversationCard = ({ conversation }) => {
    const user = useMemo(() => (conversation.users ? conversation.users[0] : null), [conversation]);

    // Guardia: si no hay usuario válido no renderizar la tarjeta
    if (!user) return null;

    return (
        <Container>
            <Link to={`/conversacion/${conversation.uuid}`}>
                <div className="image-container">
                    <img
                        src={user?.profileImg ? `${IMAGES_URL}${user.profileImg}` : NoProfileSVG}
                        alt={`perfil de ${user.name} ${user.lastName}`}
                    />
                </div>
                <div className="information">
                    <div className="texts">
                        <h4>{`${user.title ?? ""} ${user.name} ${user.lastName}`}</h4>
                        <p className={conversation.lastMessage ? "" : "enphasis"}>
                            {conversation.lastMessage
                                ? getLastMessageText(conversation.lastMessage)
                                : "Envía tu primer mensaje"}
                        </p>
                    </div>
                </div>
                {!!conversation.unreadMessagesCount && (
                    <div className="unread">
                        <span>{conversation.unreadMessagesCount > 99 ? '99+' : conversation.unreadMessagesCount}</span>
                    </div>
                )}
            </Link>
        </Container>
    );
};

export default ConversationCard;
